import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import "./blockPushFeat.scss"
import Heading from "../heading"
import HTMLReactParser from "html-react-parser";
import { graphql } from "gatsby"
import StyledButton from "../styledButton"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const BlkPushFeat = ({ content }) => {

  return (
    <section className="blk-push-feat">
      <Container>
        <Row>
          <Col md={8}>
            { content.relationships.block_featured_content_medias.length > 0 && 
              content.relationships.block_featured_content_medias.map((item, index) => {
                let className = "";
                if (index === 0) {
                  className = "imgMain";
                } else if (index === 1) {
                  className = "imgBot";
                } else if (index === 2) {
                  className = "imgTop";
                }
                return (
                  <figure className={className}>
                    <GatsbyImage image={getImage(item.relationships.field_image.gatsbyImage)} alt={item.field_image.alt} />
                  </figure>
                )
              })
            }
          </Col>
          <Col md={4}>
            <Heading
              caption={content.block_featured_content_caption}
              title={content.block_featured_content_title}
              description={HTMLReactParser(content.block_featured_content_desc.processed)}
            />
            {content.block_featured_content_link &&
              <StyledButton
                title={content.block_featured_content_link.title}
                path={content.block_featured_content_link.url}
                type="link"
              />
            }
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment featuredContent on paragraph__block_featured_content {
    block_featured_content_caption
    block_featured_content_title
    block_featured_content_link {
      title
      url
    }
    block_featured_content_desc {
      processed
    }
    relationships {
      block_featured_content_medias {
        field_image {
          alt
        }
        relationships {
          ...getImage
        }
      }
    }
  }
`

export default BlkPushFeat
